module.exports = __webpack_public_path__ + "img/DashboardReward.06e0e877.png";